import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  providers: [
    {
      provide: CarouselConfig,
      useValue: {
        interval: 5000,
        noPause: true,
        showIndicators: false,
      },
    },
  ],
})
export class HomePageComponent implements OnInit {
  showProgressBar: boolean = false;
  qrResultString: any;
  constructor(private spiner: SpinnerService, private router: Router) {}

  ngOnInit(): void {
    let element = document.querySelector('.tittle-navbar') as HTMLElement;
    element.innerHTML = 'Home';
  }

  async onCodeResult(resultString: string) {
    this.qrResultString = resultString;
    window.location.href = resultString;
    // this.goPage(this.qrResultString);
  }

  goPage(page: string) {
    this.router.navigate([page]);
  }

  moveId(id: any) {
    id.scrollIntoView();
  }
}
